import { createAction, props } from '@ngrx/store';

export const GET_PDF_DOWNLOAD_REQUEST = 'GET_PDF_DOWNLOAD_REQUEST';
export const GET_NEW_PDF_DOWNLOAD_REQUEST = 'GET_NEW_PDF_DOWNLOAD_REQUEST';
export const GET_PDF_DOWNLOAD_SUCCESS = 'GET_PDF_DOWNLOAD_SUCCESS';
export const GET_PDF_DOWNLOAD_FAILURE = 'GET_PDF_DOWNLOAD_FAILURE';
export const RESET_PDF_DOWNLOAD = 'RESET_PDF_DOWNLOAD';

export const getPdfDownloadRequest = createAction(
  GET_PDF_DOWNLOAD_REQUEST,
  props<{
    paId: string;
    documentId: string;
    documentDate: string;
  }>()
);

export const getNewPdfDownloadRequest = createAction(
  GET_NEW_PDF_DOWNLOAD_REQUEST,
  props<{
    paId: string;
    documentId: string;
    docType: 'pdf' | 'xml';
  }>()
);

export const resetPdfDownload = createAction(RESET_PDF_DOWNLOAD);

export const getPdfDownloadSuccess = createAction(
  GET_PDF_DOWNLOAD_SUCCESS,
  props<{ pdfResponse: ArrayBuffer; entityUrl?: string; version?: string }>()
);

export const getPdfDownloadFailure = createAction(GET_PDF_DOWNLOAD_FAILURE);
